import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders,HttpErrorResponse  } from "@angular/common/http";

import {OrderModel} from '../../models/order'
import {OrderDetailModel} from '../../models/orderdetail'
import serviceConfig from '../service-config';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAuthState } from '../../core/auth/_selectors/auth.selectors';
import { AppState } from '../../core/reducers/index';
import { TransferrequestService } from '../transferrequest/transferrequest.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  uri = serviceConfig.baseUrl + serviceConfig.endPoints.orderEntry;
  alturi = serviceConfig.altBaseUrl;
  alturi2 = serviceConfig.altBaseUrl2;
  uriLogisticW = serviceConfig.logisticWarehouseBaseUrl;
  altHeaders: HttpHeaders;
  headers: HttpHeaders;
  public clientId = 0;
  public IdAuth0 = "";
  public wisClientId = 0;

  constructor(private http:HttpClient, private store: Store<AppState>,
    private transferRequestService: TransferrequestService
  ) { 
    this.store.select(selectAuthState).subscribe((result) => {   
      this.altHeaders = new HttpHeaders()
                          .append('Authorization', "Bearer "+result.authToken)  
                          .append('Content-Type', 'application/json')
                          .append('accept','*/*')
                          .append("Access-Control-Allow-Origin", "*")
                          .append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept")
                          .append('accept','text/plain');


      this.headers =new HttpHeaders()
                          .append('Authorization', "Bearer "+result.authToken)  
                          .append("Access-Control-Allow-Origin", "*")
                          .append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept")
                          .append('accept','*/*')
                          .append('accept','text/plain');
    });
  }

  addOrderEntry(order:OrderModel){
    this.http.post(`${this.uri}`, order, { headers: this.altHeaders }).subscribe(res => console.log('Done'));;
  }
  sentOrderWis(order:OrderModel,clientId,companyName){
    //let url = this.alturi + serviceConfig.endPoints.wareHouseOrder;

    //let url = this.alturi + '/logistic-warehouse/Purchase/CreatePurchase?clientCode='+clientId+'&CompanyName='+companyName; //FOR PROD ENV
    let url = `${this.uriLogisticW}/Purchase/CreatePurchase?clientCode=${clientId}&CompanyName=${companyName}`; //FOR UAT ENV

    return this.http.post(`${url}`, order, { headers: this.altHeaders });
  }

  getOrderList(status:number, from:string, to:string, request:number, clientCode:number, pageNumber: number, pageSize: number) {
   //let url = this.alturi + serviceConfig.endPoints.wareHouseOrder; //FOR PROD ENV
   let url = "https://marmgodispatchwarehouse-f9bae2bwenbjgud2.eastus2-01.azurewebsites.net/Pedidos"; //FOR UAT ENV
    return this
      .http
      .get<any>(`${url}?status=${0}&clientCode=${clientCode}&pageNumber=${pageNumber}&pageSize=${pageSize}`,{ headers: this.altHeaders });
  }

  getOrderDetail(orderId:number) {
    let url = serviceConfig.baseUrl + serviceConfig.endPoints.orderDetail;
    return this
      .http
      .get<any[]>(`${url}/?orderId=${orderId}`, { headers: this.altHeaders});
  }

}
